module.exports = __webpack_public_path__ + "assets/img/sake-type.cb6c9d36.svg";